var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"x":"0px","y":"0px","viewBox":"0 0 24 24","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M16.5,1.5h-12c-1.1,0-2,0.9-2,2v12h2l0-12h12 M4.5,3.5h12"}}),_vm._v(" "),_c('path',{attrs:{"d":"M19.5,4.5h-12c-1.1,0-2,0.9-2,2v12c0,1.1,0.9,2,2,2h2v2h8v-2h2c1.1,0,2-0.9,2-2l0-12C21.5,5.4,20.6,4.5,19.5,4.5z M19.5,18.5h-12v-12h12V18.5z"}}),_vm._v(" "),_c('polygon',{attrs:{"points":"14.5,11.4 13.5,8.4 12.5,11.4 9.5,11.4 12,13.1 11,16 13.5,14.2 16,16 15,13.1 17.5,11.4 \t"}})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/IconTvSpecial.vue?vue&type=template&id=54b14926&scoped=true&
// module id = 2861
// module chunks = 5